






import { Link } from 'react-router-dom'
import { MyNav } from './mynavbar/mynavbar'

export function PageTemplate(props) {
    return <div className="page">
        <MyNav/>

        {props.children}

        <div className="page-section get-nuni">
            <button className="get-now">
                <Link to="/buynunisynth">
                    GET NUNISYNTH NOW
                </Link>
            </button>
        </div>

        <div className="product-supported-payment__methods">
            <img alt="PayPal" src="/paymenticons/PayPal.svg"/>
            <img alt="MasterCard" src="/paymenticons/Mastercard-logo.svg"/>
            <img alt="Visa" src="/paymenticons/Visa_logo.svg"/>
            <img alt="Diners Club International" src="/paymenticons/Diners_Club.svg"/>
            <img alt="American Express" src="/paymenticons/American_Express.svg"/>
            <img alt="JCB" src="/paymenticons/JCB_logo.svg"/>
            <img alt="Discover_Card" src="/paymenticons/Discover_Card.svg"/>
        </div>
    </div>
}